'use client'

import type {SiteLite} from '@/multisite/types'
import {AnalyticsPageView} from './AnalyticsPageView'
import {GoogleTagManager} from './GoogleTagManager'

type ThirdPartyToolsProps = {
  site: SiteLite
}

export function ThirdPartyTools({site}: ThirdPartyToolsProps) {
  return (
    <>
      <AnalyticsPageView site={site} />
      <GoogleTagManager ids={site.gtmIds} />
    </>
  )
}
